import { Installation } from "../Installation";
import { AgentInfo } from "../agent/AgentInfo";
import { UpdateTypeEnum } from "../enums/UpdateTypeEnum";
import { MachineUpdate } from "./MachineUpdate";
import { UpdateVersionInfo } from "./UpdateVersionInfo";

export class InstallationUpdate extends Installation {
    /** flag che indica se è attivo uno schedule per l'aggiornamento di questa installazione */
    isSetUpdateSchedule: boolean = false;

    /** Informazioni dettagliate per i sws dell'installazione, sono aggiornati oppure no? */
    installedSoftwaresVersions: UpdateVersionInfo[] = [];

    /**  Lista dei possibili aggiornamenti per cui manca però l'associazione installazion-pacchetto */
    availableSoftwareVersionsToUpgrade: UpdateVersionInfo[] = [];

    /** Lista di machineUpdate, ciascuna macchina avrà le informazioni dettagliate per i sws installati */
    updateMachines: MachineUpdate[] = [];

    /** Informazioni sull'agent */
    agentInfo: AgentInfo;

    constructor() {
        super();
    }

    public getBackendAddress(): [string, string] | undefined {
        // verifico se ha caos
        if (!this.agentInfo) return undefined;

        if (this.installedSoftwaresVersions.filter((c) => c.updateType == UpdateTypeEnum.ThirdPartySoftware && c.name.toLowerCase() == "caospf").length)
            return ["Caos", `http://${this.agentInfo.ip}/login`];
        if (this.installedSoftwaresVersions.filter((c) => c.updateType == UpdateTypeEnum.Caos).length) {
            let caosVer = this.installedSoftwaresVersions.filter((c) => c.updateType == UpdateTypeEnum.Caos)[0];
            if (caosVer.version.startsWith("5")) return ["Caos", `http://${this.agentInfo.ip}/CaosWWW`];
            else return ["Caos", `http://${this.agentInfo.ip}/login`];
        }

        if (this.installedSoftwaresVersions.filter((c) => c.updateType == UpdateTypeEnum.InLaneSw).length) {
            return ["InLane", `https://${this.agentInfo.ip}/inlane`];
        }
    }

    public parse(obj: any) {
        super.parse(obj);

        if (obj.IsSetUpdateSchedule) this.isSetUpdateSchedule = obj.IsSetUpdateSchedule;

        if (obj.InstalledSoftwaresVersions && obj.InstalledSoftwaresVersions.length > 0) {
            obj.InstalledSoftwaresVersions.forEach((e) => {
                let ms: UpdateVersionInfo = new UpdateVersionInfo();
                ms.parse(e);
                this.installedSoftwaresVersions.push(ms);
            });
        }

        if (obj.AvailableSoftwareVersionsToUpgrade && obj.AvailableSoftwareVersionsToUpgrade.length > 0) {
            obj.AvailableSoftwareVersionsToUpgrade.forEach((e) => {
                let ms: UpdateVersionInfo = new UpdateVersionInfo();
                ms.parse(e);
                this.availableSoftwareVersionsToUpgrade.push(ms);
            });
        }

        if (obj.UpdateMachines && obj.UpdateMachines.length > 0) {
            obj.UpdateMachines.forEach((e) => {
                let ms: MachineUpdate = new MachineUpdate();
                ms.parse(e);
                this.updateMachines.push(ms);
            });
        }

        if (obj.AgentInfo) {
            this.agentInfo = new AgentInfo();
            this.agentInfo.parse(obj.AgentInfo);
        }
    }

    public isUpToDate(): boolean {
        let isUpToDate = true;

        if (this.installedSoftwaresVersions) {
            this.installedSoftwaresVersions.forEach((v) => {
                if (!v.isUpToDate) isUpToDate = false;
            });
        }

        if (this.updateMachines) {
            this.updateMachines.forEach((machine) => {
                machine.installedSoftwaresVersions.forEach((v) => {
                    if (!v.isUpToDate) isUpToDate = false;
                });
            });
        }

        return isUpToDate;
    }
}
